import { render } from "./MenuTableView4.vue?vue&type=template&id=aabb921c&scoped=true"
import script from "./MenuTableView4.vue?vue&type=script&lang=js"
export * from "./MenuTableView4.vue?vue&type=script&lang=js"

import "./MenuTableView4.vue?vue&type=style&index=0&id=aabb921c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aabb921c"]])

export default __exports__